import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  id: "navigationPlaceholder",
  style: {"padding-top":"80px"}
}
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "table table-striped" }
const _hoisted_4 = { scope: "row" }
const _hoisted_5 = ["href"]

import { ref, computed, watch, onMounted } from 'vue'
    import { useOrganizationUnitId } from '@common/composables'
    import { useAdminActiveSharesPage } from '@DataSharing/Shares/pages-core'
    import AdminNavigationV2 from '@common/AdminNavigationV2.vue'

    
export default /*@__PURE__*/_defineComponent({
  __name: 'AdminActiveSharesPage',
  setup(__props) {

    document.title = 'Shares'

    const tid = useOrganizationUnitId()

    const { useActiveSharesQuery } = useAdminActiveSharesPage()

    const { modelActiveSharesQueryV1, runActiveSharesQueryV1 } = useActiveSharesQuery(parseInt(tid))

    const shares = computed(() => modelActiveSharesQueryV1.value?.Shares || [])

    onMounted(() => runActiveSharesQueryV1())

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(AdminNavigationV2, { tid: _unref(tid) }, null, 8 /* PROPS */, ["tid"])
    ]),
    _cache[1] || (_cache[1] = _createStaticVNode("<div class=\"container\"><div class=\"row\"><div class=\"col-lg-7\"><h1 style=\"font-size:2em;font-weight:300;color:#33475b;\">Active shares</h1></div><div class=\"col-lg-5 col-sm-6 text-right\"></div></div></div><hr style=\"border-color:#bbb;margin:20px 0 30px;\">", 2)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("table", _hoisted_3, [
        _cache[0] || (_cache[0] = _createElementVNode("thead", null, [
          _createElementVNode("tr", null, [
            _createElementVNode("th", { scope: "col" }, "#"),
            _createElementVNode("th", { scope: "col" }, "Workspace"),
            _createElementVNode("th", { scope: "col" }, "Portfolio"),
            _createElementVNode("th", { scope: "col" }, "Data"),
            _createElementVNode("th", { scope: "col" }, "Shared by"),
            _createElementVNode("th", { scope: "col" }, "Shared with"),
            _createElementVNode("th", { scope: "col" }, "Shared at"),
            _createElementVNode("th", { scope: "col" }, "Shared for")
          ])
        ], -1 /* CACHED */)),
        _createElementVNode("tbody", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(shares.value, (s, i) => {
            return (_openBlock(), _createElementBlock("tr", {
              key: s.Id
            }, [
              _createElementVNode("th", _hoisted_4, _toDisplayString(i+1), 1 /* TEXT */),
              _createElementVNode("td", null, _toDisplayString(s.WorkspaceName), 1 /* TEXT */),
              _createElementVNode("td", null, _toDisplayString(s.PortfolioName), 1 /* TEXT */),
              _createElementVNode("td", null, [
                _createElementVNode("a", {
                  href: s.ResourceUrl,
                  target: "_blank"
                }, _toDisplayString(s.ResourceName), 9 /* TEXT, PROPS */, _hoisted_5)
              ]),
              _createElementVNode("td", null, _toDisplayString(s.SharedBy), 1 /* TEXT */),
              _createElementVNode("td", null, _toDisplayString(s.SharedWith), 1 /* TEXT */),
              _createElementVNode("td", null, _toDisplayString(s.SharedAt), 1 /* TEXT */),
              _createElementVNode("td", null, _toDisplayString(s.SharedFor), 1 /* TEXT */)
            ]))
          }), 128 /* KEYED_FRAGMENT */))
        ])
      ])
    ])
  ]))
}
}

})